import { INew_TableAction } from '@lla-platform/core/core-data-access'
import { IAdminWeeklyTiersUpdate } from '../../interfaces/admin-shop-tires.interface'
import {
  IAdminUpdatePermissionsRequest,
  IBulkEditLocationsRequest,
  IBulkEditPermissionsRequest
} from '../../interfaces/admin-user-permissions.interface'
import { IAdminUpdateLocationRequest } from '../../interfaces/admin-locations-list.interface'
import { IAdminCreateLocationRequest } from '../../interfaces/admin-location-create.interface'
import { IAdminDailyReports } from '../../interfaces/admin-daily-reports.interface'
import { IPostQueueMessageRequest } from '../../interfaces/admin-queue-messages.interface'
import { IApplyAttentionProposalsRequest } from '../../interfaces/admin-attention-proposals.interface'

export class AdminGetWeeklyTires {
  static readonly type = '[admin] Admin Get Weekly Tires'
}

export class AdminUpdateWeeklyTires {
  static readonly type = '[admin] Admin Update Weekly Tires'
  constructor(public payload: IAdminWeeklyTiersUpdate) {}
}

export class AdminOverrideWeeklyTires {
  static readonly type = '[admin] Admin Override Weekly Tires'
}

export class AdminOverrideMonthlyTargets {
  static readonly type = '[admin] Admin Override Monthly Targets'
}

export class AdminGetProtractorLocationsList {
  static readonly type = '[admin] Admin Get Protractor Locations List'
}

export class AdminGetUsersList {
  static readonly type = '[admin] Admin Get Users List'
  constructor(
    public info: INew_TableAction,
    public top?: number
  ) {}
}

export class AdminGetUserPermissions {
  static readonly type = '[admin] Admin Get User Permissions'
  constructor(public userId: string) {}
}

export class AdminUpdateUserPermissions {
  static readonly type = '[admin] Admin Update User Permissions'
  constructor(
    public userId: string,
    public payload: IAdminUpdatePermissionsRequest
  ) {}
}

export class AdminGetAllPermissions {
  static readonly type = '[admin] Admin Get All Permissions'
}

export class AdminBulkEditLocations {
  static readonly type = '[admin] Admin Bulk Edit Locations'
  constructor(public payload: IBulkEditLocationsRequest) {}
}

export class AdminBulkEditPermissions {
  static readonly type = '[admin] Admin Bulk Edit Permissions'
  constructor(public payload: IBulkEditPermissionsRequest) {}
}

export class AdminBulkInsertPermissions {
  static readonly type = '[admin] Admin Bulk Insert Permissions'
  constructor(public payload: IBulkEditPermissionsRequest) {}
}

export class GetAdminLocationsList {
  static readonly type = '[admin] Get Admin Locations List'
  constructor(public info: INew_TableAction) {}
}

export class AdminGetLocation {
  static readonly type = '[admin] Admin Get Location'
  constructor(public locationId: string) {}
}

export class AdminUpdateLocation {
  static readonly type = '[admin] Admin Update Location'
  constructor(
    public locationId: string,
    public payload: IAdminUpdateLocationRequest
  ) {}
}

export class AdminCreateLocation {
  static readonly type = '[admin] Admin Create Location'
  constructor(public payload: IAdminCreateLocationRequest) {}
}

export class AdminGetDailyReports {
  static readonly type = '[admin] Admin Get Daily Reports'
  constructor(public locationId: string) {}
}

export class AdminImportDailyReports {
  static readonly type = '[admin] Admin Import Daily Reports'
  constructor(
    public locationId: string,
    public payload: IAdminDailyReports
  ) {}
}

export class AdminImportPreLLAInvoices {
  static readonly type = '[admin] Admin Import Pre LLA Invoices'
  constructor(
    public locationId: string,
    public payload: IAdminDailyReports
  ) {}
}

export class AdminPostQueueMessage {
  static readonly type = '[admin] Admin Post Queue Message'
  constructor(public payload: IPostQueueMessageRequest) {}
}

export class AdminGetAttentionProposals {
  static readonly type = '[admin] Admin Get Attention Proposals'
}

export class AdminApplyAttentionProposals {
  static readonly type = '[admin] Admin Apply Attention Proposals'
  constructor(public payload: IApplyAttentionProposalsRequest) {}
}
